export const itemSelectionList = 
{
    "Aircon Services" :
        [
            "General Servicing",
            "Gas Refill Full Tank",
            "Gas Refill Half Tank",
            "Chemical Wash",
            "Chemical Hydro Wash",
            "Chemical Overhaul",
            "Condenser Cleaning",
            "Condenser Chem. Wash",
            "Drain Pipe Flush",
            "High ceiling - tall ladder",
            "Other Cost"
        ]  ,
    "Domestic Services" :
        [
            "Other Cost"
        ]  ,
    "Handyman Services" :
        [
            "Other Cost",
            "Handyman Visit Cost"
        ]
}

export const userItemSelectionList = 
{
    "Aircon Services" :
        [
            "General Servicing", 
            "Gas Refill Full Tank",        
            "Chemical Overhaul",
            "Chemical Hydro Wash",
            "Chemical Wash",
            "Gas Refill Half Tank",            
            "Condenser Cleaning",
            "Condenser Chem. Wash"
        ],
    "Domestic Services" :
        [
            "Other Cost"
        ] ,
    "Handyman Services" :
        [
            "Other Cost"
        ]  
    
}

// Aircon items offered in Singapore only. The backend prices them from the
// country's AirconPricingProfile (chemicalHydroBase) and returns 0 where the
// base is 0, so they must not be offered elsewhere.
export const SG_ONLY_AIRCON_ITEMS = ["Chemical Hydro Wash"]

// An aircon item list for a country (countryCd "sg" / "ae" / "my"; none = SG).
export const airconItemsForCountry = (items, countryCd) =>
    !countryCd || countryCd.toLowerCase() === 'sg'
        ? items
        : items.filter((item) => !SG_ONLY_AIRCON_ITEMS.includes(item))
